module.exports = __webpack_public_path__ + "img/img9.1c3ded3c.svg";